import { render, staticRenderFns } from "./complaintDetail.vue?vue&type=template&id=69c5cb42&scoped=true"
import script from "./complaintDetail.vue?vue&type=script&lang=ts"
export * from "./complaintDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c5cb42",
  null
  
)

export default component.exports